<template>
  <div id="user-profile">
    <profile-header :eduProgram="eduProgram" />
    <!-- profile info  -->
    <section id="profile-info">
      <b-row>
        <!-- about suggested page and twitter feed -->
        <b-col lg="3" cols="12" order="2" order-lg="1">
          <b-card>
            <!-- about -->
            <div>
              <h5 class="text-capitalize mb-75 font-weight-bolder">اسم</h5>
              <b-card-text>
                {{ eduProgram.name }}
              </b-card-text>
              <hr />
              <h5 class="text-capitalize mb-75 font-weight-bolder">شرح</h5>
              <b-card-text v-html="eduProgram.explanation">
                <!-- {{ eduProgram.explanation }} -->
              </b-card-text>
              <hr />
              <h5 class="text-capitalize mb-75 font-weight-bolder">لائحة</h5>
              <b-card-text>
                {{ eduProgram.programlist.name }}
              </b-card-text>
              <hr />
              <h5 class="text-capitalize mb-75 font-weight-bolder">
                نوع الاشتراك
              </h5>
              <b-card-text>
                {{ eduProgram.subscription_type }}
              </b-card-text>
            </div>
          </b-card>
        </b-col>
        <!--/ about suggested page and twitter feed -->

        <!-- post -->
        <b-col lg="6" cols="12" order="1" order-lg="2">
          <profile-post :eduProgram="eduProgram" />
        </b-col>
        <!-- post -->

        <!-- latest photos suggestion and polls -->
        <b-col lg="3" cols="12" order="3">
          <profile-suggestion :eduProgram="eduProgram" />
        </b-col>
        <!--/ latest photos suggestion and polls -->

        <!--/ load more  -->
      </b-row>
    </section>
    <!--/ profile info  -->
  </div>
</template>

<script>
import { BRow, BCol } from "bootstrap-vue";

import ProfileHeader from "./ProfileHeader.vue";
import ProfileAbout from "./ProfileAbout.vue";
import ProfileSuggestedPages from "./ProfileSuggestedPages.vue";
import ProfileTwitterFeed from "./ProfileTwitterFeed.vue";
import ProfilePost from "./ProfilePost.vue";
import ProfileSuggestion from "./ProfileSuggestion.vue";
import ProfilePolls from "./ProfilePolls.vue";
import profileBottom from "./profileBottom.vue";
import Auth from "@/Apis/Auth";
import EduProgramsController from "@/Controllers/EduProgramsController";

/* eslint-disable global-require */
export default {
  components: {
    BRow,
    BCol,

    ProfileHeader,
    ProfileAbout,
    ProfileSuggestedPages,
    ProfileTwitterFeed,
    ProfilePost,
    ProfileSuggestion,
    ProfilePolls,
    profileBottom,
  },
  data() {
    return {
      profileData: {},
      eduProgram: {},
    };
  },
  async created() {
    //تفاصيل البرنامج
    this.$mobileTitle.label=this.$i18n.t('edu_programs.program_details'); 

    var id = localStorage.getItem("eduProgram");
    if (this.$route.params.eduProgramId) {
      id = this.$route.params.eduProgramId;
    }
    const data = await new EduProgramsController().Details(id, {
      with: ["students","programlist"],
    });
    this.eduProgram = data;
  },
};
/* eslint-disable global-require */
</script>

<style lang="scss" >
@import "@core/scss/vue/pages/page-profile.scss";
</style>
